<template>
  <div class="moreInfoCardTitle">
    <h3>{{title}}</h3>
    <div style="display: flex;align-items: center">
      <h3
        v-if="score!== null && score !== undefined && score !== ''"
        style="margin-right: 20px"
      >得分: {{score}}</h3>
      <h3
        v-if="combo_score!== null && combo_score !== undefined && combo_score !== ''"
        style="margin-right: 20px"
      >规则得分: {{combo_score}}</h3>
      <el-popover
        v-if="qrcode"
        style="margin: 0 5px;"
        @show="useqrcode"
        placement="top-start"
        trigger="hover"
      >
        <canvas :id="canvasId"></canvas>
        <el-button class="iconfont icon-erweima erweima" size="mini" slot="reference">二维码</el-button>
      </el-popover>
    </div>
  </div>
</template>
<script>
import QRCode from 'qrcode'
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    score: {
      type: String | Number,
      default: '',
    },
    combo_score: {
      type: String | Number,
      default: '',
    },
    qrcode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      canvasId: '',
    }
  },
  created() {
    this.createCanvasId()
  },
  methods: {
    createCanvasId() {
      this.canvasId = 'canvas' + Math.round(Math.random() * 10000)
    },
    useqrcode() {
      const canvas = document.getElementById(this.canvasId)
      QRCode.toCanvas(canvas, this.qrcode, function (error) {
        if (error) console.error(error)
      })
    },
  },
}
</script>
<style lang="less">
.moreInfoCardTitle {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>